import { type ExtendedAppointmentAttachment } from "@repo/api";
import { LightMode, ListView, ListViewItem, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { hasItems } from "@repo/utils";

import { AppointmentFileItem } from "../fileListItem/AppointmentFileItem";
import { groupAppointmentAttachments } from "../utils";
import { AttachmentAccordionItem, type FilesListBaseProps } from "./FilesList";

interface AppointmentFilesListProps extends FilesListBaseProps {
  files?: ExtendedAppointmentAttachment[];
}
export const AppointmentFilesList = ({
  files,
  editable,
  loading,
  loadingFileId,
  onDownload,
}: AppointmentFilesListProps) => {
  if (!hasItems(files)) {
    return null;
  }
  const groupedFiles = groupAppointmentAttachments(files);

  return (
    <AttachmentAccordionItem
      id="appointment-attachments"
      title={`${t("label.appointment")} (${files?.length})`}
    >
      {Object.entries(groupedFiles).map(([appointmentNumber, files]) => (
        <ListView
          key={`appointment-${files?.[0]?.orderNumber}-attachments`}
          id={`appointment-${files?.[0]?.orderNumber}-attachments`}
        >
          <ListViewItem
            title={`${t("label.appointment")} ${appointmentNumber}`}
            addOn={
              <Text
                color={LightMode.colourTextAndIcon3}
                textStyle="Body.S"
                title={t("label.project_id")}
              >
                {t("label.order_id")}: {files?.[0]?.orderNumber}
              </Text>
            }
          />
          {files?.map((attachment) => (
            <AppointmentFileItem
              key={`appointment-${files?.[0]?.orderNumber}-attachment-${attachment.fileName}${attachment.currentTimestamp}`}
              file={attachment}
              editable={editable}
              onDownload={onDownload}
              loading={loading}
              loadingFileId={loadingFileId}
            />
          ))}
        </ListView>
      ))}
    </AttachmentAccordionItem>
  );
};
